
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/48a76d22d9ac5f76d0a02ef6a9b7d940.jpg"
          alt="Peaceful therapy environment"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      {/* Logo Overlay */}
      <div className="absolute top-32 left-1/2 transform -translate-x-1/2 z-20">
        <img
          src="https://static.readdy.ai/image/97be066482875b82b2fddabc195c0943/9c4245f84ac76278cd8c587241d9204a.png"
          alt="Solutions Healthcare LLC"
          className="h-32 w-auto drop-shadow-2xl"
        />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center mt-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-5xl md:text-7xl font-bold text-neutral-gray mb-6 leading-tight">
            Compassionate Mental<br />Health Care
          </h1>
          <p className="text-2xl md:text-3xl text-neutral-blue mb-4 font-light">
            For Adults & Seniors in Aurora, Colorado
          </p>
          <p className="text-lg md:text-xl text-neutral-gray max-w-2xl mx-auto mb-12 leading-relaxed">
            Evidence-based psychiatric care delivered with personalized attention by experienced clinicians
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <Link
              to="/appointment"
              className="bg-primary hover:bg-primary-dark text-white px-8 py-4 rounded-full text-lg font-semibold transition-all flex items-center space-x-2 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
            >
              <span>Schedule Your Appointment</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/services"
              className="border-2 border-neutral-gray text-neutral-gray hover:bg-neutral-gray hover:text-white px-8 py-4 rounded-full text-lg font-semibold transition-all flex items-center space-x-2 whitespace-nowrap cursor-pointer"
            >
              <span>Learn About Our Services</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </motion.div>

        {/* Scroll Indicator */}
        <motion.div
          className="absolute bottom-12 left-1/2 transform -translate-x-1/2"
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <i className="ri-arrow-down-line text-neutral-gray text-3xl"></i>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
